<template>
<div>
  <div class="w-full text-NotoSansLight min-h-50">
    <div class="flex flex-col">
      <div class="member-content-hd mb-8 pt-3 px-2 md:hidden">
        <h3 class="text-NotoSansRegular text-base lg:text-lg pb-1 border-b md:border-b-0 md:text-center">
          常用收件地址
        </h3>
      </div>
      <div class="member-content">
        <div class="member-content-bd pb-5">
          <div class="section section-latest-order">
            <p class="text-sm md:text-base mb-4 textColorRed px-4 lg:px-6">若欲修改「雜誌收件地址」，請至【
              <router-link :to="{ name: 'magazineSendBack'}" class="underline">顧客服務>雜誌訂戶服務</router-link>】修改</p>

            <div class="editBtnList flex justify-end mb-2">
              <button class="button-gray border py-2 px-4 rounded mx-1 focus:outline-none" @click="isBadge = true">
                + 新增地址
              </button>
            </div>

            <div v-if="addressList">
              <div class="w-full md:flex border-b border-gray-400 bg-white rounded py-4 px-4 md:px-6" v-for="(item, index) in addressList" :key="index">
                <div class="w-full md:w-4/5 mb-2 md:mb-0">
                  <ul>
                    <li class="mb-3">姓名&emsp;{{ item.name }}
                      <label v-if="item.is_preset === 1" class="ml-4 mb-0 px-3 py-1 bgLiveABCRed rounded-full text-white text-sm">預設</label></li>
                    <li class="mb-3">手機&emsp;{{ item.mobile ? item.mobile : '' }}</li>
                    <li class="mb-3">住家&emsp;{{ item.tel ? item.tel : '' }}</li>
                    <li>地址&emsp;{{ item.zip_code }}{{ item.city }}{{ item.district }}{{ item.address }}</li>
                  </ul>
                </div>
                <div class="w-full md:w-1/5 flex md:flex-col justify-end md:justify-between items-center md:items-end">
                  <a class="mr-2 md:mr-0 underline cursor-pointer" @click.prevent="deleteItem(item)" :class="{ hidden: item.is_preset === 1 }">刪除</a>
                  <button @click="setDefault(item)" class="border border-gray-500 hover:border-gray-700 text-gray-500 hover:text-gray-700 py-1 px-3 rounded focus:outline-none cursor-pointer" v-if="item.is_preset === 0">
                    設為預設地址
                  </button>
                </div>
              </div>
            </div>
            <div v-else>
                <img src="~@/assets/icon/Pulse.gif" class="mx-auto h-12">
            </div>

          </div>
        </div>
      </div>
    </div>

    <PaginateComponent v-if="addressList" :pagination="pagination" v-on:pageChangeHandler="pageChangeHandler" />

  </div>
  <AddAddressPop v-on:close="close" v-if="isBadge" v-on:addData="addData" />
</div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import AddAddressPop from '@/components/popup/AddAddressPop'
import PaginateComponent from '@/components/modules/Paginatation'
export default {
  name: 'ShippingAddress',
  data () {
    return {
      isBadge: false,
      addressList: null,

      pageSize: 10,

      // pagination
      pagination: {
        currentPage: 1,
        length: 1
      }
    }
  },
  props: {
  },
  components: {
    AddAddressPop,
    PaginateComponent
  },
  computed: {
    ...mapGetters([
      'user'
    ])
  },
  mounted () {
    this.getList()
  },
  updated () {
  },
  methods: {
    getList () {
      let self = this
      axios.get(`/user/recipients?page=${self.pagination.currentPage}&pageSize=${self.pageSize}&user_id=${self.user.id}`)
        .then((response) => {
          self.addressList = response.data.data
          self.pagination.length = response.data.last_page
        })
    },
    close (close) {
      this.isBadge = false
    },
    setDefault (item) {
      let self = this
      let obj = {
        name: item.name,
        mobile: item.mobile ? item.mobile : '',
        tel: item.tel ? item.tel : '',
        city: item.city,
        district: item.district,
        zip_code: item.zip_code,
        address: item.address,
        is_preset: 1
      }
      axios.patch(`/user/recipients/${item.id}`, obj)
        .then((response) => {
          self.getList()
        })
    },
    async deleteItem (item) {
      let self = this
      await axios.delete(`/user/recipients/${item.id}`)
        .then((response) => {
          self.getList()
        })

      if (self.addressList.length === 1) {
        self.pagination.currentPage = 1
        self.getList()
      }
    },
    addData (addData) {
      let self = this
      axios.post('/user/recipients', addData)
        .then((response) => {
          self.getList()
          self.isBadge = false
        })
    },
    async pageChangeHandler (pageChangeHandler) {
      let self = this
      self.pagination.currentPage = pageChangeHandler

      self.getList()
      self.isBadge = false
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
